import React, { useState, useContext, useEffect } from "react";
import {
  Grid,
  Typography,
  Divider,
  ButtonGroup,
  Button,
  Card,
  CircularProgress,
  Avatar,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

import DashboardContext from "../../../context/dashboard/DashboardContext";

const PaypalDisputes = () => {
  const dashboardContext = useContext(DashboardContext);
  const { getDashboardDisputes, disputes } = dashboardContext;

  const [totalRecords, setTotalRecords] = useState({
    internal: 0,
    external: 0,
    total: 0,
  });
  const [gridHeight, setGridHeight] = useState("40%");
  const [loading, setLoading] = useState(false);
  const [daySelected, setDaySelected] = useState("Today");
  const [dayButtonColor, setDayButtonColor] = useState({
    todayBG: "#ffffff",
    todayText: "normal",
    yesterdayBG: "#ffffff",
    yesterdayText: "normal",
  });

  useEffect(() => {
    if (daySelected) {
      if (daySelected === "Today") {
        setDayButtonColor({
          todayBG: "#dddddd",
          todayText: "bold",
          yesterdayBG: "#ffffff",
          yesterdayText: "normal",
        });
      } else if (daySelected === "Yesterday") {
        setDayButtonColor({
          todayBG: "#ffffff",
          todayText: "normal",
          yesterdayBG: "#dddddd",
          yesterdayText: "bold",
        });
      }
    }
  }, [daySelected]);

  const useStyles = makeStyles((theme) => ({
    headerText: {
      color: theme.palette.primary.contrastText,
    },
    bgColor: {
      backgroundColor: theme.palette.primary.dark,
    },
    buttonOutline: {
      "&:focus": {
        outline: "none",
      },
    },
    internal: {
      width: theme.spacing(1),
      height: theme.spacing(1),
      backgroundColor: "#FF3D0D",
    },
    external: {
      width: theme.spacing(1),
      height: theme.spacing(1),
      backgroundColor: "#0080ff",
    },
  }));

  const classes = useStyles();

  useEffect(() => {
    var from = "";
    var to = "";
    setLoading(true);
    if (daySelected === "Today") {
      from = new Date(new Date().setHours(0, 0, 0, 0)).toISOString();
      to = new Date(new Date().setHours(24, 0, 0, 0)).toISOString();
    } else if (daySelected === "Yesterday") {
      from = new Date(new Date().setHours(-24, 0, 0, 0)).toISOString();
      to = new Date(new Date().setHours(0, 0, 0, 0)).toISOString();
    }
    getDashboardDisputes(from, to);
    //eslint-disable-next-line
  }, [daySelected]);

  useEffect(() => {
    if (disputes) {
      // Set grid height
      if (disputes.disputes.length <= 2) {
        setGridHeight("40%");
      } else if (disputes.disputes.length === 3) {
        setGridHeight("55%");
      } else if (disputes.disputes.length === 4) {
        setGridHeight("70%");
      } else {
        setGridHeight("100%");
      }
      // Set total records
      var total_records = 0;
      var total_external = 0;
      var total_internal = 0;
      for (let x in disputes.disputes) {
        total_records += disputes.disputes[x].total;
        total_external += disputes.disputes[x].external;
        total_internal += disputes.disputes[x].internal;
      }
      setTotalRecords({
        internal: total_internal,
        external: total_external,
        total: total_records,
      });
      setLoading(false);
    }
  }, [disputes]);

  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Accordion
      expanded={expanded === "panel1"}
      onChange={handleChange("panel1")}
    >
      <AccordionSummary
        aria-controls="panel1bh-content"
        id="panel1bh-header"
        className={classes.bgColor}
      >
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          style={{
            height: 100,
          }}
        >
          <Grid item>
            <Typography variant="h6" className={classes.headerText}>
              Disputes{" "}
            </Typography>{" "}
          </Grid>{" "}
          <Grid item>
            <Grid
              container
              direction="row"
              alignItems="center"
              style={{
                height: "90%",
              }}
              spacing={1}
            >
              <Grid item>
                <Typography variant="h6" className={classes.headerText}>
                  <strong> {totalRecords.total} </strong>{" "}
                </Typography>{" "}
              </Grid>{" "}
              <Grid item>
                <Typography variant="h6" className={classes.headerText}>
                  cases{" "}
                </Typography>{" "}
              </Grid>{" "}
            </Grid>{" "}
          </Grid>{" "}
          <Grid item xs={12}>
            {" "}
            {disputes && loading === false ? (
              <Card
                style={{
                  height: 30,
                }}
              >
                <Grid
                  container
                  direction="row"
                  style={{
                    height: "100%",
                  }}
                >
                  <Grid
                    item
                    xs={6}
                    style={{
                      height: "100%",
                    }}
                  >
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      style={{
                        height: "100%",
                      }}
                    >
                      <Grid item>
                        <Avatar className={classes.internal}> </Avatar>{" "}
                      </Grid>{" "}
                      <Grid
                        item
                        style={{
                          width: "5%",
                        }}
                      >
                        {" "}
                      </Grid>{" "}
                      <Grid item>
                        <Typography variant="subtitle1">
                          Internal: <strong> {totalRecords.internal} </strong>{" "}
                        </Typography>{" "}
                      </Grid>{" "}
                    </Grid>{" "}
                  </Grid>{" "}
                  <Grid
                    item
                    xs={6}
                    style={{
                      height: "100%",
                    }}
                  >
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      style={{
                        height: "100%",
                      }}
                    >
                      <Grid item>
                        <Avatar className={classes.external}> </Avatar>{" "}
                      </Grid>{" "}
                      <Grid
                        item
                        style={{
                          width: "5%",
                        }}
                      >
                        {" "}
                      </Grid>{" "}
                      <Grid item>
                        <Typography variant="subtitle1">
                          External: <strong> {totalRecords.external} </strong>{" "}
                        </Typography>{" "}
                      </Grid>{" "}
                    </Grid>{" "}
                  </Grid>{" "}
                </Grid>{" "}
              </Card>
            ) : (
              <Grid
                container
                direction="row"
                alignItems="center"
                justifyContent="center"
                style={{
                  height: "80%",
                }}
              >
                <Grid item>
                  <CircularProgress
                    style={{
                      color: "#ffffff",
                    }}
                  />{" "}
                </Grid>{" "}
              </Grid>
            )}{" "}
          </Grid>{" "}
        </Grid>{" "}
      </AccordionSummary>{" "}
      <AccordionDetails>
        {" "}
        {disputes && loading === false ? (
          <Grid
            container
            direction="row"
            spacing={1}
            style={{
              height: 250,
            }}
          >
            <Grid
              item
              xs={12}
              style={{
                height: "15%",
              }}
            >
              <Grid
                container
                direction="row"
                alignItems="stretch"
                style={{
                  height: "100%",
                }}
              >
                <Grid
                  item
                  style={{
                    width: "55%",
                  }}
                >
                  <Typography variant="body1">
                    <strong> Reasons: </strong>{" "}
                  </Typography>{" "}
                </Grid>{" "}
              </Grid>{" "}
            </Grid>{" "}
            <Grid
              item
              xs={12}
              style={{
                height: "70%",
              }}
            >
              <Grid
                container
                direction="row"
                alignItems="stretch"
                style={{
                  height: gridHeight,
                }}
              >
                {disputes.disputes.map((each, index) => {
                  return (
                    <Grid item xs={12} key={index}>
                      <Grid
                        container
                        direction="row"
                        alignItems="center"
                        style={{
                          height: "100%",
                        }}
                      >
                        <Grid
                          item
                          style={{
                            width: "76%",
                          }}
                        >
                          <Typography variant="body2">
                            {" "}
                            {each.reason}{" "}
                          </Typography>{" "}
                        </Grid>{" "}
                        <Grid
                          item
                          style={{
                            width: "5%",
                          }}
                        >
                          <Avatar
                            style={{
                              float: "right",
                            }}
                            className={classes.internal}
                          >
                            {" "}
                          </Avatar>{" "}
                        </Grid>{" "}
                        <Grid
                          item
                          style={{
                            width: "2%",
                          }}
                        >
                          {" "}
                        </Grid>{" "}
                        <Grid
                          item
                          style={{
                            width: "5%",
                          }}
                        >
                          <Typography variant="body2">
                            {" "}
                            {each.internal}{" "}
                          </Typography>{" "}
                        </Grid>{" "}
                        <Grid
                          item
                          style={{
                            width: "5%",
                          }}
                        >
                          <Avatar
                            style={{
                              float: "right",
                            }}
                            className={classes.external}
                          >
                            {" "}
                          </Avatar>{" "}
                        </Grid>{" "}
                        <Grid
                          item
                          style={{
                            width: "2%",
                          }}
                        >
                          {" "}
                        </Grid>{" "}
                        <Grid
                          item
                          style={{
                            width: "5%",
                          }}
                        >
                          <Typography variant="body2">
                            {" "}
                            {each.external}{" "}
                          </Typography>{" "}
                        </Grid>{" "}
                      </Grid>{" "}
                    </Grid>
                  );
                })}{" "}
              </Grid>{" "}
            </Grid>{" "}
            <Grid item xs={12}>
              <Divider variant="fullWidth" />
            </Grid>{" "}
            <Grid
              item
              xs={12}
              style={{
                height: "15%",
              }}
            >
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                style={{
                  height: "100%",
                }}
              >
                <Grid item>
                  <Typography variant="subtitle1">
                    <strong> This Month </strong>{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid item xs={9}>
                  <Grid
                    container
                    direction="row"
                    style={{
                      height: "100%",
                    }}
                  >
                    <Grid
                      item
                      xs={6}
                      style={{
                        height: "100%",
                      }}
                    >
                      <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        style={{
                          height: "100%",
                        }}
                      >
                        <Grid item>
                          <Avatar className={classes.internal}> </Avatar>{" "}
                        </Grid>{" "}
                        <Grid
                          item
                          style={{
                            width: "5%",
                          }}
                        >
                          {" "}
                        </Grid>{" "}
                        <Grid item>
                          <Typography variant="subtitle1">
                            Internal:{" "}
                            <strong>
                              {" "}
                              {disputes.monthly_disputes.internal}{" "}
                            </strong>{" "}
                          </Typography>{" "}
                        </Grid>{" "}
                      </Grid>{" "}
                    </Grid>{" "}
                    <Grid
                      item
                      xs={6}
                      style={{
                        height: "100%",
                      }}
                    >
                      <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        style={{
                          height: "100%",
                        }}
                      >
                        <Grid item>
                          <Avatar className={classes.external}> </Avatar>{" "}
                        </Grid>{" "}
                        <Grid
                          item
                          style={{
                            width: "5%",
                          }}
                        >
                          {" "}
                        </Grid>{" "}
                        <Grid item>
                          <Typography variant="subtitle1">
                            External:{" "}
                            <strong>
                              {" "}
                              {disputes.monthly_disputes.external}{" "}
                            </strong>{" "}
                          </Typography>{" "}
                        </Grid>{" "}
                      </Grid>{" "}
                    </Grid>{" "}
                  </Grid>{" "}
                </Grid>{" "}
              </Grid>{" "}
            </Grid>{" "}
          </Grid>
        ) : (
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="center"
            style={{
              height: "100%",
            }}
          >
            <Grid item>
              <CircularProgress />
            </Grid>{" "}
          </Grid>
        )}{" "}
      </AccordionDetails>{" "}
    </Accordion>
  );
};

export default PaypalDisputes;
